import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { StepsContextProvider } from "../../context/PIstepsContext";
import useMedia from "../../hooks/useMedia";
import { PIStepRoutes } from "../../routes/PIRoutes/StepRoutes";
import { PERSONAL_INFO_STEPS } from "../../components/PIForm/Steps/step3/utils";

export default function PIWithStepsContext() {
  const [mobileNav, setShowMobNav] = useState(false);
  const [step, setStep] = useState(PERSONAL_INFO_STEPS.personDetails);

  const isTablet = useMedia("(min-width: 768px)");
  const pathname = useHistory().location.pathname;

  useEffect(() => {
    if (window.innerWidth < 768 || isTablet) {
      setShowMobNav(false);
    }
  }, [pathname, isTablet]);

  return (
    <StepsContextProvider>
      {mobileNav && (
        <div className="shadow-layout" onClick={() => setShowMobNav(false)} />
      )}
      <PIStepRoutes step={step} setStep={setStep} />
    </StepsContextProvider>
  );
}
